module.exports = __webpack_public_path__ + "static/media/RewindIcon.2e95376e.svg";